import {
  RejectedMessageType,
  SubscribedMessageType,
  UnsubscribedMessageType,
  UpdatedMessageType
} from '../Socket/types'

export type CurrencyDefinitionType = {
  blocked: boolean
  blockedRegions: string[]
  depositedAs: string
  fiat: boolean
  key: string
  name: string
  toppedUpFrom: string[]
  withdrawnAs: string[]
  withdrawnFrom: string
}

export type MoneyType = {
  symbol: string
  value: string
}

/* eslint-disable camelcase */
export type PrecisionType = {
  amount: number
  min_amount: number
  price: number
}
/* eslint-enable camelcase */

export type DivisorType = {
  symbol: string
  value: number
}

export type SymbolType = string

export type MarketStatusType =
  | 'open' // The symbol is open for trading, all order types and cancels are accepted.
  | 'closed' // No orders will be accepted, nothing will match.
  | 'halt' // No matching will occur. Most order types will be accepted and we will calculate an opening auction.
  | 'halt_freeze' // During a freeze we will not allow order cancels and will only allow new orders that decrease the imbalance.
  | 'suspended' // suspended no orders will be accepted
  | 'system_outage' // No orders will be accepted, nothing will match

/* eslint-disable camelcase */
export type InstrumentType = {
  readonly auction_price: number
  readonly auction_size: number
  readonly auction_time: string
  readonly base_currency: string
  readonly base_currency_scale: number
  readonly counter_currency: string
  readonly counter_currency_scale: number
  readonly id: number
  readonly imbalance: number
  readonly leverage_ratio: number[]
  readonly lot_size: number
  readonly lot_size_scale: number
  readonly margin_enabled: boolean
  readonly min_order_size: number
  readonly min_order_size_calc?: number
  readonly min_order_size_scale: number
  readonly min_price_increment: number
  readonly min_price_increment_scale: number
  readonly price_increment: number
  readonly status: MarketStatusType
  readonly symbol: SymbolType
  readonly volume_increment: number
}
/* eslint-enable camelcase */

export type FormattedInstrumentType = {
  readonly base: string
  readonly baseName: string
  readonly counter: string
  readonly counterName: string
  readonly id: number
  readonly symbol: SymbolType
  readonly text: string
  readonly value: string
}

export type SymbolMessageType =
  | RejectedMessageType
  | SubscribedMessageType
  | UnsubscribedMessageType
  | (InstrumentType & UpdatedMessageType)

const SEPARATOR = '-'
const parseSymbol = (symbol: SymbolType) => {
  const data = symbol.split(SEPARATOR)
  return {
    base: data[0] as string,
    counter: data[1] as string
  }
}

const serialiseSymbol: (symbol: SymbolType) => string = (symbol) => symbol

const toSymbol: (symbol: string) => SymbolType = (symbol) => symbol

const defaultLocalCurrency = 'USD'

export type CurrencyResponseType = {
  ok: boolean
  response: {
    currencies: CurrencyDefinitionType[]
  }
}

export { defaultLocalCurrency, parseSymbol, serialiseSymbol, toSymbol }
